export const parseafechainicioServicio = e => {
  //e.setMonth(e.getMonth() + 1);

  let day = e.getDate();
  let month = e.getMonth() + 1;
  let year = e.getFullYear().toString();

  if (month < 10) {
    month = `0${month}`;
  }
  if (day < 10) {
    day = `0${day}`;
  }

  return `${day}-${month}-${year}`;
};

export const parseafechainicioServicioProc = e => {
  const d = new Date(e);
  d.setMonth(d.getMonth() + 1);

  let day = d.getDate();
  let month = d.getMonth() + 1;
  let year = d.getFullYear().toString();

  if (month < 10) {
    month = `0${month}`;
  }
  if (day < 10) {
    day = `0${day}`;
  }

  return `${day}-${month}-${year}`;
};

export const parseaFecha = fechaN => {
  let fechaArray = fechaN.split("-"); // dividir la cadena en un arreglo de 3 elementos: día, mes y año
  let e = new Date(fechaArray[2], fechaArray[1] - 1, fechaArray[0]);

  e.setMonth(e.getMonth() + 1);

  let day = e.getDate();
  let month = e.getMonth() + 1;
  let year = e.getFullYear().toString();

  if (month < 10) {
    month = `0${month}`;
  }
  if (day < 10) {
    day = `0${day}`;
  }

  return `${day}-${month}-${year}`;
};

export const dateToString = e => {
  const d = new Date(e);
  d.setMonth(d.getMonth() + 1);

  let day = d.getDate();
  let month = d.getMonth() + 1;
  let year = d.getFullYear().toString();

  if (month < 10) {
    month = `0${month}`;
  }
  if (day < 10) {
    day = `0${day}`;
  }

  return `${day}-${month}-${year}`;
};

export const dateToStringTime = (e, rangoFin) => {
  let formattedDate = "";
  let day = ("0" + e.getDate()).slice(-2);
  let month = ("0" + (e.getMonth() + 1)).slice(-2);
  let year = e.getFullYear().toString();
  let hours = ("0" + e.getHours()).slice(-2);
  let minutes = ("0" + e.getMinutes()).slice(-2);
  let seconds = ("0" + e.getSeconds()).slice(-2);

  if (rangoFin === 1) {
    formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  } else {
    formattedDate = `${year}-${month}-${day} ${"23"}:${"59"}:${"59"}`;
  }

  return formattedDate;
};

export const addOneMonth = fecha => {
  if (typeof fecha !== "string") {
    throw new Error("La entrada debe ser una cadena.");
  }

  const [day, month, year] = fecha.split("-").map(Number);

  let newMonth = month + 1;
  let newYear = year;

  if (newMonth > 12) {
    newMonth = 1;
    newYear += 1;
  }

  const newDay = String(day).padStart(2, "0");
  const newMonthString = String(newMonth).padStart(2, "0");
  const newYearString = String(newYear);

  return `${newDay}-${newMonthString}-${newYearString}`;
}